import * as toastr from "toastr";
import { ICalendarEvent } from "motw_core/Calendar/ICalendarEvent";
import * as React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { UnmountAllSwals } from "source/app/services/Shared/RenderSwal/RenderSwal";
import { StyleClass } from "../../../../Shared/Styles/CSS";
import { DeleteCalendarEventActionAsync } from "./DeleteCalendarEventActionAsync";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";

export function DeleteEventLink({ eventData }: { eventData: ICalendarEvent }) {
    if (eventData.etag === ``) {
        return null;
    }

    const linkText = eventData.isRepeating ? `Delete occurence` : `Delete`;

    return (
        <div
            className={StyleClassAuto({
                marginTop: `10px`,
            })}
        >
            <IconWithText
                iconSuffix={EGlyphicon.trash}
                whenClicked={async () => {
                    UnmountAllSwals();
                    await DeleteCalendarEventActionAsync(eventData);
                }}
                displayAsBlock={false}
                withClass={StyleClassAuto({
                    opacity: 0.4,
                    color: `white`,
                    marginRight: `10px`,
                })}
            >
                {linkText}
            </IconWithText>
        </div>
    );
}
